import datacentral from '@/utils/axios/datacentral'
import {
    QuarterlyReportFilters,
    QuarterlyReportResponse,
} from '../types/quarterly-report'
import { QuarterlyInsightResponse } from './quarterly-report-gemini'

const BASE_URL = '/reports/survey/quarterly'

export const getQuarterlyReport = async (
    filters: QuarterlyReportFilters
): Promise<QuarterlyReportResponse> => {
    const params = new URLSearchParams()
    params.append('from_date', filters.from_date)
    params.append('to_date', filters.to_date)

    if (filters.service_names && filters.service_names.length > 0) {
        filters.service_names.forEach((name) =>
            params.append('service_names[]', name)
        )
    }

    if (filters.employee_ids && filters.employee_ids.length > 0) {
        filters.employee_ids.forEach((id) =>
            params.append('employee_ids[]', id.toString())
        )
    }

    if (
        filters.customer_sale_followers &&
        filters.customer_sale_followers.length > 0
    ) {
        filters.customer_sale_followers.forEach((id) =>
            params.append('customer_sale_followers[]', id.toString())
        )
    }

    if (
        filters.customer_cs_followers &&
        filters.customer_cs_followers.length > 0
    ) {
        filters.customer_cs_followers.forEach((id) =>
            params.append('customer_cs_followers[]', id.toString())
        )
    }

    const response = await datacentral.get<QuarterlyReportResponse>(
        `${BASE_URL}?${params.toString()}`
    )
    return response.data
}

export const exportQuarterlyReportExcel = async (
    filters: QuarterlyReportFilters,
    aiInsights?: QuarterlyInsightResponse | null
): Promise<void> => {
    const response = await datacentral.post(
        `${BASE_URL}/export-excel`,
        {
            from_date: filters.from_date,
            to_date: filters.to_date,
            ...(filters.service_names?.length && {
                service_names: filters.service_names,
            }),
            ...(filters.employee_ids?.length && {
                employee_ids: filters.employee_ids,
            }),
            ...(filters.customer_sale_followers?.length && {
                customer_sale_followers: filters.customer_sale_followers,
            }),
            ...(filters.customer_cs_followers?.length && {
                customer_cs_followers: filters.customer_cs_followers,
            }),
            ...(aiInsights && { ai_insights: aiInsights }),
        },
        { responseType: 'blob' }
    )

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'quarterly-survey-report.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
}
